import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';

import imgLaGomera from "../../../assets/img/content/home/experiences/la-gomera/home.jpg"
import imgTeideByNight from "../../../assets/img/content/home/experiences/teide-by-night/home.jpg"

//CSS
import styles from "./experiences.module.less";

export default function Experiences () {
  const [t,i18n] = useTranslation("home","global");

  return (
    <div className={styles.experiences}>
      <div className={styles.experience}>
        <div className={styles.text}>
          {t('No olvides visitar nuestro apartado especial')}
          <span> {t('“Live the experience”')}</span>
        </div>
      </div>

      <div className={styles.experience}>
        <Link  to={"/"+i18n.language+"/experiences/la-gomera"}>
          <img src={imgLaGomera} />
          <div className={styles.sheet}>
            <div className={styles.background}>&nbsp;</div>
            <div className={styles.contentexperience}>
              <div className={styles.name}>{t('La mágia de')}<br /> {t('la Isla Colombina')}</div>
            </div>
            <div className={styles.content}></div>
          </div>
        </Link>
      </div>

      <div className={styles.experience}>
        <Link to={"/"+i18n.language+"/experiences/teide-by-night"}>
          <img src={imgTeideByNight} />
          <div className={styles.sheet}>
            <div className={styles.background}>&nbsp;</div>
            <div className={styles.contentexperience}>
              <div className={styles.name}>{t('Noches estrelladas')}<br /> {t('en el Teide')}</div>
            </div>
          </div>
        </Link>
      </div>

    </div>
  );

}